import { ActionTypes } from "../../../constants/ActionConstants";

export const getCampaignMedia = (campaignId, pageNo, pageSize) => ({
  type: ActionTypes.MediaSelection.GET_CAMPAIGN_MEDIA,
  payload: { campaignId, pageNo, pageSize },
});

export const clearCampaignMedia = () => ({
  type: ActionTypes.MediaSelection.CLEAR_CAMPAIGN_MEDIA,
});

export const selectMedia = (
  campaignId,
  cityId,
  campaignMediaBean,
  isAsync
) => ({
  type: ActionTypes.MediaSelection.SELECT_MEDIA,
  payload: { campaignId, cityId, campaignMediaBean, isAsync },
});

export const unSelectMedia = (campaignId, campaignMedia, mediaId) => ({
  type: ActionTypes.MediaSelection.UN_SELECT_MEDIA,
  payload: { campaignId, campaignMedia, mediaId },
});

export const confirmCampaignPlan = (campaignId, campaignName, history) => ({
  type: ActionTypes.MediaSelection.CONFIRM_CAMPAIGN_PLAN,
  payload: { campaignId, campaignName, history },
});

//Create new campaign media
export const createMedia = (
  createMediaBean,
  imageFiles,
  campaignId,
  cityId
) => ({
  type: ActionTypes.MediaSelection.CREATE_CAMPAIGN_MEDIA,
  payload: { createMediaBean, imageFiles, campaignId, cityId },
});

export const openViewMediaImagesForm = (processDataObject) => ({
  type: ActionTypes.MediaSelection.OPEN_VIEW_MEDIA_IMAGES_MODAL,
  payload: { processDataObject },
});

export const closeViewMediaImagesForm = () => ({
  type: ActionTypes.MediaSelection.CLOSE_VIEW_MEDIA_IMAGES_MODAL,
});
